// react_ujs optionally requires 'react-dom/client' for React 18+.
// On React 16 this branch never runs at runtime; this shim satisfies webpack resolution.
module.exports = require('react-dom');
